import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { AnimatePresence } from "framer-motion";
import ProtectedRoute from "./components/common/ProtectedRoute";
import AuthWrapper from "./components/Auth/AuthWrapper";
import SignIn from "./components/Auth/SignIn";
import SignUp from "./components/Auth/SignUp";
import Dashboard from "./components/Dashboard/Dashboard";
import "./App.css";

function App() {
  return (
    <Router>
      <AuthProvider>
        <AnimatePresence mode="wait">
          <Routes>
            <Route
              path="/signup"
              element={
                <AuthWrapper>
                  <SignUp />
                </AuthWrapper>
              }
            />
            <Route
              path="/signin"
              element={
                <AuthWrapper>
                  <SignIn />
                </AuthWrapper>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/"
              element={
                <AuthWrapper>
                  <SignIn />
                </AuthWrapper>
              }
            />
          </Routes>
        </AnimatePresence>
      </AuthProvider>
    </Router>
  );
}

export default App;
